import type { ApolloCache } from '@frameio/graphql-client';

export function evictAncestorFolders(
  cache: ApolloCache<any>,
  assetIds: string[]
) {
  assetIds.forEach((id) => {
    cache.evict({
      id: cache.identify({
        __typename: 'Asset',
        id,
      }),
      fieldName: 'ancestorFolders',
      broadcast: false,
    });
  });
}
